import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';

@MergeSchema()
export class LeadAccountMergeData {

    @MergeField()
    type: string;

    @MergeField()
    name: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;
}

export const LeadAccountMergeSchema = getSchema(LeadAccountMergeData);